import axios from "axios";
import {apiServiceUrl} from "./skeleton/skeletonSaga";

function authHeaders() {
    const token = localStorage.getItem("sessionToken");
    return {Authorization: `Bearer ${token}`};
}

export async function restartDbotService(serviceName: string): Promise<void> {
    await axios.post(
        apiServiceUrl + `dbot/service/restart?service_name=${encodeURIComponent(serviceName)}`,
        {},
        {headers: authHeaders()}
    );
}

